//const Backofficebff         : string = "/backofficebff/service/api/v1";
//const BackofficebffV2        : string = "/backofficebff/service/api/v2";
const Backofficebff: any = import.meta.env.VITE_BACKOFFICEBFF!;

export const MobilePanelConfigurationCommand: any = {
    RemoveMobilePanelConfiguration: Backofficebff + '/v1/mobilpanelconfiguration/config',
    UpdateMobilePanelConfiguration: Backofficebff + '/v1/mobilpanelconfiguration/update',
    CreateMobilePanelConfiguration: Backofficebff + '/v1/mobilpanelconfiguration/create',
    FilterMobilePanelConfiguration: Backofficebff + '/v1/mobilpanelconfiguration/get',
    CreateMobilePanelConfigurationV2: Backofficebff + '/v2/mobilepanel/create-configuration',
    DeleteMobilPanelConfigurationCache: Backofficebff + '/v1/mobilpanelconfiguration/delete-cache',
};
